import React, { useState, useEffect } from 'react'
import { Button, FormControl, Table, Form } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import { getCsvDataForSalesReport } from '../../utils/csvdatagetter'
import { ExportCSV } from '../_reusedcomponents/ExportCSVView'
import moment from 'moment'
import 'moment/locale/de'
import { useDateFilter } from '../../utils/filterutils'
import { parseFloatCurrency } from '../../utils/formatting/floatnumberparsing'
moment.locale('de')

const SalesReportHeaderView = ({ handleSearchInput, setFilterbar, filteredReports, loadReport, options }) => {
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [boutiqueSelection, setBoutiqueSelection] = useState("")
    const [dateSelection, setDateSelection] = useState({ "startDate": moment(moment().subtract(13, 'days').toDate()).format("DD.MM.YYYY"), "endDate": moment(moment().toDate()).format("DD.MM.YYYY")})

    const loadDateRangePicker = () => {
        const showCustomRangeLabel = true

        const getDefaultValue = () => {
            if (dateSelect !== "" && dateSelect.start._d !== "") {
                const startDate = moment(dateSelect.start._d).format("DD.MM.YYYY")
                const endDate = moment(dateSelect.end._d).format("DD.MM.YYYY")
                return (startDate +
                    ' - ' + endDate)
            } else {
                const startDate = moment(moment().subtract(13, 'days').toDate()).format("DD.MM.YYYY")
                const endDate = moment(moment().toDate()).format("DD.MM.YYYY")
                return (startDate +
                    ' - ' + endDate)
            }
        }
        const handleApply = (event, picker) => {
            picker.element.val(
                picker.startDate.format('DD.MM.YYYY') +
                ' - ' +
                picker.endDate.format('DD.MM.YYYY')
            )
            handleDatePickerCallback(picker.startDate, picker.endDate)
            setDateSelection({ "startDate": picker.startDate.format('DD.MM.YYYY'), "endDate": picker.endDate.format('DD.MM.YYYY') })
        }
        const handleCancel = (event, picker) => {
            picker.element.val('')
            handleClearFilter()
        }
        const handleCallback = (start, end) => {
            //24.01.22 RB: onCallback from DateRangePicker seems to be broken, 
            //handles setting the datepicker variables via handleApply now(called when pressing OK button)

            //handleDatePickerCallback(start, end)
        }

        let predefRange = {}
        predefRange[window.i18n('today')] = [moment(), moment()]
        predefRange[window.i18n('days7')] = [
            moment().subtract(6, 'days').toDate(),
            moment().toDate(),
        ]
        predefRange[window.i18n('days14')] = [
            moment().subtract(13, 'days').toDate(),
            moment().toDate(),
        ]
        predefRange[window.i18n('days30')] = [
            moment().subtract(29, 'days').toDate(),
            moment().toDate(),
        ]
        predefRange[window.i18n('monthThis')] = [
            moment().startOf('month').toDate(),
            moment().endOf('month').toDate(),
        ]
        predefRange[window.i18n('monthLast')] = [
            moment().subtract(1, 'month').startOf('month').toDate(),
            moment().subtract(1, 'month').endOf('month').toDate(),
        ]
        predefRange[window.i18n('yearThis')] = [
            moment().startOf('year').toDate(),
            moment().endOf('year').toDate(),
        ]
        predefRange[window.i18n('all')] = [
            moment(moment.utc("0001-01-01")).format('DD.MM.YYYY'),
            moment().toDate(),
        ]

        return (
            <DateRangePicker initialSettings={{
                showCustomRangeLabel,
                locale: {
                    cancelLabel: window.i18n('reset'),
                    applyLabel: window.i18n('ok'),
                    customRangeLabel: window.i18n('manually')
                },
                autoUpdateInput: false,
                ranges: predefRange,
            }} onApply={handleApply} onCancel={handleCancel}
                onCallback={(start, end) => handleCallback(start, end)} isClearable={true}>
                <FormControl className="dateFilterForm" size="sm" defaultValue={getDefaultValue()} />
            </DateRangePicker>
        )
    }

    const handleSetBoutiqueSelection = (boutiqueSelection) => {
        let selectedBoutique = options[0].ReportParameters.find(y => y.Order == 1).SalesPoints.find(x => x.Name == boutiqueSelection)
        setBoutiqueSelection(selectedBoutique.SalesPointSysId)
    }

    const loadBoutiqueSelection = () => {
        if (options !== null && options[0] !== undefined) {
            let boutiqueNames = options[0].ReportParameters.find(y => y.Order == 1).SalesPoints.map(x => x.Name).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            let all = boutiqueNames.splice(boutiqueNames.findIndex(a => a.includes('Alle')), 1)
            boutiqueNames.splice(0, 0, all[0]);
            return (
                <FormControl className="filterForm reportSelect" defaultValue="" as="select" size="sm" onChange={(e) => handleSetBoutiqueSelection(e.target.value)}>
                    {boutiqueNames.map(x => <option>{x}</option>)}
                </FormControl>
            )
        }
    }

    const handleReportLoad = () => {
        loadReport(dateSelection.startDate, dateSelection.endDate, boutiqueSelection)
    }

    return (
        <>
            <h1 className="title">{window.i18n('salesReport')}</h1>
            {window.i18n('chooseTimeframe')}
            <div className="inline">
                {loadDateRangePicker()}
                &nbsp;
                {loadBoutiqueSelection()}
                &nbsp;&nbsp;
                <Button variant="light" size="sm" className="form filter-button form-control sales-report-btn" onClick={handleReportLoad}>{window.i18n('loadReport')}</Button>
            </div>
            <br />

            <div className="inline">
                <FormControl className="globalSearch" as="input" placeholder={window.i18n('search')} onChange={handleSearchInput}></FormControl>
                <Button variant="light" className="form filter-button form-control" onClick={setFilterbar}>&#8711; Filter</Button>
                <ExportCSV csvData={getCsvDataForSalesReport(filteredReports)} fileName={window.i18n('salesReport')} />
                <div className="clear"></div>
            </div>
        </>
    )
}

const SalesReportTableView = ({ filteredReport, handleSortReport, filterable, DateSelect, StateSelect, expandRow, getIsExpandedRow  }) => {
    const getTotalAmount = (filteredReports) => {
        let total = 0
        let numbers = filteredReports.map(x => parseInt(x.Amount))
        total = numbers.reduce((a, b) => a + b, 0)

        return total
    }

    const getTotalPrices = (filteredReports, field) => {
        let total = 0
        let numbers = filteredReports.map(x => parseFloat(x[field]))
        total = numbers.reduce((a, b) => a + b, 0)

        return total
    }

    return (
        <>
            <div className="tablet-transactions-scroll">
                <Table className="articletype-table table-sm table-sales-striped-immediate ">
                    <thead className="sticky-table-header">
                        <th className="mainColumn">{window.i18n('salePoint')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'SalesPoint')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('saleDate')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Date')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('articleNumberFaex')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'FAEXArticleNumber')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('articleNumberDesigner')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'ArticleNumberDesigner')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('articleName')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'ArticleName')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('colour')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Colour')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('size')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Size')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('amount')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Amount')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('defaultSalePrice')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'SalesPrice')}>&#8593; &#8595;</a></th>
                        {/*<th className="mainColumn-large">{window.i18n('paymentGross')}*/}
                        {/*            <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'PaymentForFAEXBrutto')}>&#8593; &#8595;</a></th>*/}
                        {/*<th className="mainColumn-large">{window.i18n('paymentNet')}*/}
                        {/*            <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'PaymentForFAEXNetto')}>&#8593; &#8595;</a></th>*/}
                        <th></th>
                    </thead>

                    {filterable ? <thead>
                        <th></th>
                        <th>{DateSelect()}</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        {/*<th></th>*/}
                        {/*<th></th>*/}
                        <th></th>
                    </thead> : null}

                    <tbody>
                        {filteredReport.map(entry => 
                            <>
                                <tr>
                                    <td>{entry.SalesPoint}</td>
                                    <td>{entry.Date}</td>
                                    <td>{entry.FAEXArticleNumber}</td>
                                    <td>{entry.ArticleNumberDesigner}</td>
                                    <td>{entry.ArticleName}</td>
                                    <td>{entry.Colour}</td>
                                    <td>{entry.Size}</td>
                                    <td className="numberColumn">{entry.Amount}</td>
                                    <td className="numberColumn">{parseFloatCurrency(entry.SalesPrice)}</td>
                                    {/*<td className="numberColumn">{parseFloatCurrency(entry.PaymentForFAEXBrutto)}</td>*/}
                                    {/*<td className="numberColumn">{parseFloatCurrency(entry.PaymentForFAEXNetto)}</td>*/}
                                </tr>
                            </>
                            
                        )}

                        <tr className="stockReport-row">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{window.i18n('sum') + ":"}</td>
                            <td className="numberColumn">{getTotalAmount(filteredReport)}</td>
                            <td className="numberColumn">{parseFloatCurrency(getTotalPrices(filteredReport, "SalesPrice"))}</td>
                            {/*<td className="numberColumn">{parseFloatCurrency(getTotalPrices(filteredReport, "PaymentForFAEXBrutto"))}</td>*/}
                            {/*<td className="numberColumn">{parseFloatCurrency(getTotalPrices(filteredReport, "PaymentForFAEXNetto"))}</td>*/}
                        </tr>
                    </tbody>

                </Table>
            </div>
        </>
    )
}

export { SalesReportHeaderView, SalesReportTableView }